import { Modal } from 'antd';
import api from '../../services/api';

/**
 * Helpers de ocupação diária das máquinas (balanço entrada - saída vs capacidade).
 *
 * `warnIfMachineNearCapacity(machineId)`: consulta o balanço do dia e, se a
 * máquina estiver com ocupação elevada (>= OCCUPANCY_WARNING_PCT), abre uma
 * modal de aviso mostrando a capacidade e o saldo atual. Não bloqueia o fluxo —
 * o operador decide se continua. Falhas na consulta são silenciosas.
 *
 * Usado ao selecionar a máquina na adição de RC e ao iniciar o processamento
 * de um tambor (após ler o QR code).
 */
export const OCCUPANCY_WARNING_PCT = 90;

const fmt = (v) => Number(v || 0).toLocaleString('pt-BR', { maximumFractionDigits: 1 });

export async function warnIfMachineNearCapacity(machineId) {
  if (!machineId) return false;
  try {
    const res = await api.dashboard.getMachinesDailyBalance();
    const m = (Array.isArray(res.data) ? res.data : []).find((r) => r.machine_id === machineId);
    // Sem capacidade cadastrada não há como avaliar ocupação.
    if (!m || m.occupancyPct == null) return false;
    if (m.occupancyPct < OCCUPANCY_WARNING_PCT) return false;

    Modal.warning({
      title: 'Atenção: máquina com ocupação elevada',
      okText: 'Entendi',
      content: (
        <div style={{ fontSize: 16, lineHeight: 1.7 }}>
          A máquina <strong>{m.code}</strong> está com{' '}
          <strong style={{ color: '#c1281a' }}>{fmt(m.occupancyPct)}%</strong> da capacidade.
          <br />
          Saldo de hoje: <strong>{fmt(m.saldo)} L</strong> de{' '}
          <strong>{fmt(m.capacity_liters)} L</strong> de capacidade.
          <br />
          <span style={{ fontSize: 14, color: '#6b7280' }}>
            Considere fazer a descarga antes de adicionar mais líquido.
          </span>
        </div>
      ),
    });
    return true;
  } catch (err) {
    // Silencioso: o aviso é auxiliar e não pode travar o fluxo do operador.
    // eslint-disable-next-line no-console
    console.error('Erro ao verificar ocupação da máquina:', err?.response?.data?.error || err.message);
    return false;
  }
}
